export const REMOVE_LESSON = "REMOVE_LESSON"
export const REMOVE_LESSON_SUCCESS = "REMOVE_LESSON_SUCCESS"
export const REMOVE_LESSON_CLEAN = "REMOVE_LESSON_CLEAN"
export const REMOVE_LESSON_ERROR = "REMOVE_LESSON_ERROR"
